<template>
  <app-modal ref="modal" name="robotics-user-modal" :title="title" @before-open="beforeOpen" :is-submitting="isLoading"  @before-close="beforeClose" @on-ok="onOk">
    <b-alert :show="!!formErrors" variant="danger">
      <ul>
        <li>{{formErrors}}</li>
      </ul>
    </b-alert>
    <app-form
      ref="form"
      @on-submit="onSubmit"
      :schema="schema"
      :data="formModel"
    />
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import AppForm from '@/components/app-form/';
import { mapActions } from 'vuex';
import RoboticsUserProxy from '@/store/proxies/robotics-user-proxy';

const formSchema = context => ({
  name: {
    label: context.$t('user.name'),
    placeholder: `${context.$t('app.enter')} ${context.$t('user.name')}`,
    type: 'input',
    validation: 'required',
  },
  phone: {
    label: context.$t('user.phone'),
    placeholder: `${context.$t('app.enter')} ${context.$t('user.phone')}`,
    type: 'input',
    validation: 'required',
  },
  email: {
    label: context.$t('user.email'),
    placeholder: `${context.$t('app.enter')} ${context.$t('user.email')}`,
    type: 'input',
    validation: { required: true, email: true },
  },
  password: {
    label: context.$t('user.password'),
    placeholder: `${context.$t('app.enter')} ${context.$t('user.password')}`,
    type: 'input',
    inputType: 'password',
    validation: 'required',
  },
  role: {
    label: context.$t('user.role'),
    placeholder: `${context.$t('app.enter')} ${context.$t('user.role')}`,
    type: 'select',
    options: [
      { value: 'ROBOTICS_ROLE_ADMIN', text: context.$t('user.admin') },
      { value: 'ROBOTICS_ROLE_ACCOUNTANT', text: context.$t('user.accountant') },
    ],
  },
});


export default {
  name: 'RoboticsUserModal',
  components: {
    AppModal,
    AppForm,
  },
  data() {
    return {
      title: 'Create Robotic User',
      formErrors: '',
      formModel: {
        name: null,
        phone: null,
        password: null,
        email: null,
        role: 'ROBOTICS_ROLE_ACCOUNTANT',
      },
      isLoading: false,
      schema: [],
    };
  },
  computed: {},
  methods: {
    ...mapActions('auth', ['updateUserProfile']),
    onSubmit(formModel) {
      this.$refs.form.validate().then((isValid) => {
        if (isValid) {
          this.formErrors = '';
          this.isLoading = true;
          if (formModel.id) {
            new RoboticsUserProxy().updateUserRole(formModel).then((res) => {
              this.$refs.modal.close();
              this.$emit('on-ok', res);
            })
            .catch((e) => {
              this.formErrors = e.detail;
            })
            .finally(() => {
              setTimeout(() => {
                this.isLoading = false;
              }, 500);
            });
          } else {
            const payload = {
              ...formModel,
              user_name: formModel.email,
            };
            new RoboticsUserProxy().createUser(payload).then((res) => {
              this.$refs.modal.close();
              this.$emit('on-ok', res);
            })
            .catch((e) => {
              this.formErrors = e.message;
            })
            .finally(() => {
              setTimeout(() => {
                this.isLoading = false;
              }, 500);
            });
          }
        }
      });
    },
    onOk() {
      this.$refs.form.submit();
    },
    beforeClose() {
      this.formModel = {
        id: null,
        name: null,
        phone: null,
        password: null,
        email: null,
        role: 'ROBOTICS_ROLE_ACCOUNTANT',
      };
      this.schema = formSchema(this);
    },
    beforeOpen(params) {
      const schema = formSchema(this);
      this.title = params.model.user ? `${this.$t('user.updateRole')} - ${params.model.name}` : this.$t('user.createUser');
      if (params.model.user) {
        this.formModel = {
          id: params.model.user.id,
          role: params.model.roboticsrole.role,
        };
        this.schema = { role: schema.role };
      } else {
        this.schema = schema;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/user/user-list-modal/robotics-user-modal.vue